import { defineMessages } from 'react-intl';

export default defineMessages({
  menu_label: {
    id: 'Main navigation menu',
    defaultMessage: 'Main navigation menu',
  },
  close_label: {
    id: 'Close menu',
    defaultMessage: 'Close menu',
  },
});
